import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import PageHeaders from '../../../Utils/PageHeaders';
import HubNav from '../../ResourceHubPages/HubNav/HubNav';
import SecurityHero from './components/SecurityHero';
import SecurityPillars from './components/SecurityPillars';
import PartnersSection from '../Home/components/PartnersSection';
import { BLACK } from '@plootus/common';
import Canonical from '../../../Utils/Canonical/Canonical';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
  },
}));

const Security = () => {
  const classes = useStyles();

  return (
  <>    
    <HubNav />
    <PageHeaders
      title="Security & Privacy - Plootus"
      description="Plootus takes security seriously. Learn about our encryption, data protection, privacy policies, and how we keep your financial information safe."
      keywords="Plootus security, data protection, encryption, privacy, financial security, secure investing"
      canonicalUrl="https://www.plootus.com/security"
    />
    <Canonical />
    <main className={classes.root}>
      <SecurityHero />
      <SecurityPillars />
      <PartnersSection titleColor={BLACK} titleFontSize="30px" subtitleFontSize="15px" />
    </main>
    </>
  );
};

export default Security;
